import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Root as Scrollytelling, Animation, Pin } from '@bsmnt/scrollytelling';

// ============================================
// ALBUM DATA
// ============================================

const VINYL_ALBUMS = [
  {
    id: 'mbdtf', title: 'My Beautiful Dark Twisted Fantasy', artist: 'Kanye West',
    label: '/labels/mbdtf.svg', year: 2010, recordLabel: 'Roc-A-Fella / Def Jam',
    catalog: 'B0014695-01', format: 'LP, Album', country: 'US',
    genres: ['Hip Hop', 'Art Pop'], condition: 'Near Mint (NM)',
    tracks: [
      { side: 'A', num: 1, title: 'Dark Fantasy', duration: '4:40' },
      { side: 'A', num: 2, title: 'Gorgeous', duration: '5:57' },
      { side: 'A', num: 3, title: 'POWER', duration: '4:52' },
      { side: 'A', num: 4, title: 'All of the Lights (Interlude)', duration: '1:02' },
      { side: 'A', num: 5, title: 'All of the Lights', duration: '4:59' },
      { side: 'B', num: 6, title: 'Monster', duration: '6:18' },
      { side: 'B', num: 7, title: 'So Appalled', duration: '6:37' },
      { side: 'B', num: 8, title: 'Devil in a New Dress', duration: '5:52' },
      { side: 'B', num: 9, title: 'Runaway', duration: '9:07' },
      { side: 'C', num: 10, title: 'Hell of a Life', duration: '5:27' },
      { side: 'C', num: 11, title: 'Blame Game', duration: '7:49' },
      { side: 'C', num: 12, title: 'Lost in the World', duration: '4:16' },
      { side: 'C', num: 13, title: 'Who Will Survive in America', duration: '1:38' },
    ],
  },
  {
    id: 'tpab', title: 'To Pimp a Butterfly', artist: 'Kendrick Lamar',
    label: '/labels/tpab.svg', year: 2015, recordLabel: 'Top Dawg / Aftermath / Interscope',
    catalog: 'B0023213-01', format: 'LP, Album', country: 'US',
    genres: ['Hip Hop', 'Jazz Rap', 'Funk'], condition: 'Mint (M)',
    tracks: [
      { side: 'A', num: 1, title: 'Wesley\'s Theory', duration: '4:47' },
      { side: 'A', num: 2, title: 'For Free? (Interlude)', duration: '2:10' },
      { side: 'A', num: 3, title: 'King Kunta', duration: '3:54' },
      { side: 'A', num: 4, title: 'Institutionalized', duration: '4:30' },
      { side: 'B', num: 5, title: 'These Walls', duration: '5:01' },
      { side: 'B', num: 6, title: 'u', duration: '4:28' },
      { side: 'B', num: 7, title: 'Alright', duration: '3:39' },
      { side: 'C', num: 8, title: 'For Sale? (Interlude)', duration: '4:51' },
      { side: 'C', num: 9, title: 'Momma', duration: '4:43' },
      { side: 'C', num: 10, title: 'Hood Politics', duration: '4:52' },
      { side: 'D', num: 11, title: 'How Much a Dollar Cost', duration: '4:21' },
      { side: 'D', num: 12, title: 'Complexion (A Zulu Love)', duration: '4:23' },
      { side: 'D', num: 13, title: 'The Blacker the Berry', duration: '5:28' },
      { side: 'D', num: 14, title: 'You Ain\'t Gotta Lie', duration: '4:01' },
      { side: 'D', num: 15, title: 'i', duration: '5:36' },
      { side: 'D', num: 16, title: 'Mortal Man', duration: '12:07' },
    ],
  },
  {
    id: 'ok-computer', title: 'OK Computer', artist: 'Radiohead',
    label: '/labels/ok-computer.svg', year: 1997, recordLabel: 'Parlophone',
    catalog: 'NODATA 02', format: 'LP, Album', country: 'UK',
    genres: ['Alternative Rock', 'Art Rock'], condition: 'Very Good Plus (VG+)',
    tracks: [
      { side: 'A', num: 1, title: 'Airbag', duration: '4:44' },
      { side: 'A', num: 2, title: 'Paranoid Android', duration: '6:23' },
      { side: 'A', num: 3, title: 'Subterranean Homesick Alien', duration: '4:27' },
      { side: 'B', num: 4, title: 'Exit Music (For a Film)', duration: '4:24' },
      { side: 'B', num: 5, title: 'Let Down', duration: '4:59' },
      { side: 'B', num: 6, title: 'Karma Police', duration: '4:21' },
      { side: 'C', num: 7, title: 'Fitter Happier', duration: '1:57' },
      { side: 'C', num: 8, title: 'Electioneering', duration: '3:50' },
      { side: 'C', num: 9, title: 'Climbing Up the Walls', duration: '4:45' },
      { side: 'C', num: 10, title: 'No Surprises', duration: '3:48' },
      { side: 'D', num: 11, title: 'Lucky', duration: '4:19' },
      { side: 'D', num: 12, title: 'The Tourist', duration: '5:24' },
    ],
  },
  {
    id: 'wish-you-were-here', title: 'Wish You Were Here', artist: 'Pink Floyd',
    label: '/labels/wish-you-were-here.svg', year: 1975, recordLabel: 'Harvest / Columbia',
    catalog: 'SHVL 814', format: 'LP, Album', country: 'UK',
    genres: ['Progressive Rock', 'Art Rock'], condition: 'Very Good Plus (VG+)',
    tracks: [
      { side: 'A', num: 1, title: 'Shine On You Crazy Diamond (Parts I-V)', duration: '13:30' },
      { side: 'A', num: 2, title: 'Welcome to the Machine', duration: '7:31' },
      { side: 'B', num: 3, title: 'Have a Cigar', duration: '5:08' },
      { side: 'B', num: 4, title: 'Wish You Were Here', duration: '5:34' },
      { side: 'B', num: 5, title: 'Shine On You Crazy Diamond (Parts VI-IX)', duration: '12:31' },
    ],
  },
  {
    id: 'kid-a', title: 'Kid A', artist: 'Radiohead',
    label: '/labels/kid-a.svg', year: 2000, recordLabel: 'Parlophone',
    catalog: '7243 5 29590 1 8', format: '2xLP, Album', country: 'UK',
    genres: ['Electronic', 'Experimental Rock'], condition: 'Near Mint (NM)',
    tracks: [
      { side: 'A', num: 1, title: 'Everything in Its Right Place', duration: '4:11' },
      { side: 'A', num: 2, title: 'Kid A', duration: '4:44' },
      { side: 'A', num: 3, title: 'The National Anthem', duration: '5:51' },
      { side: 'B', num: 4, title: 'How to Disappear Completely', duration: '5:56' },
      { side: 'B', num: 5, title: 'Treefingers', duration: '3:42' },
      { side: 'C', num: 6, title: 'Optimistic', duration: '5:15' },
      { side: 'C', num: 7, title: 'In Limbo', duration: '3:31' },
      { side: 'D', num: 8, title: 'Idioteque', duration: '5:09' },
      { side: 'D', num: 9, title: 'Morning Bell', duration: '4:35' },
      { side: 'D', num: 10, title: 'Motion Picture Soundtrack', duration: '7:01' },
    ],
  },
  {
    id: 'in-rainbows', title: 'In Rainbows', artist: 'Radiohead',
    label: '/labels/in-rainbows.svg', year: 2007, recordLabel: 'TBD Records',
    catalog: 'TBD-001', format: 'LP, Album', country: 'UK',
    genres: ['Alternative Rock', 'Art Rock'], condition: 'Mint (M)',
    tracks: [
      { side: 'A', num: 1, title: '15 Step', duration: '3:58' },
      { side: 'A', num: 2, title: 'Bodysnatchers', duration: '4:02' },
      { side: 'A', num: 3, title: 'Nude', duration: '4:15' },
      { side: 'A', num: 4, title: 'Weird Fishes/Arpeggi', duration: '5:18' },
      { side: 'A', num: 5, title: 'All I Need', duration: '3:49' },
      { side: 'B', num: 6, title: 'Faust Arp', duration: '2:10' },
      { side: 'B', num: 7, title: 'Reckoner', duration: '4:50' },
      { side: 'B', num: 8, title: 'House of Cards', duration: '5:28' },
      { side: 'B', num: 9, title: 'Jigsaw Falling into Place', duration: '4:09' },
      { side: 'B', num: 10, title: 'Videotape', duration: '4:40' },
    ],
  },
  {
    id: 'remain-in-light', title: 'Remain in Light', artist: 'Talking Heads',
    label: '/labels/remain-in-light.svg', year: 1980, recordLabel: 'Sire',
    catalog: 'SRK 6095', format: 'LP, Album', country: 'US',
    genres: ['New Wave', 'Post-Punk', 'Afrobeat'], condition: 'Very Good Plus (VG+)',
    tracks: [
      { side: 'A', num: 1, title: 'Born Under Punches (The Heat Goes On)', duration: '5:51' },
      { side: 'A', num: 2, title: 'Crosseyed and Painless', duration: '4:45' },
      { side: 'A', num: 3, title: 'The Great Curve', duration: '6:23' },
      { side: 'A', num: 4, title: 'Once in a Lifetime', duration: '4:19' },
      { side: 'B', num: 5, title: 'Houses in Motion', duration: '4:29' },
      { side: 'B', num: 6, title: 'Seen and Not Seen', duration: '3:20' },
      { side: 'B', num: 7, title: 'Listening Wind', duration: '4:28' },
      { side: 'B', num: 8, title: 'The Overload', duration: '5:42' },
    ],
  },
  {
    id: 'a-love-supreme', title: 'A Love Supreme', artist: 'John Coltrane',
    label: '/labels/a-love-supreme.svg', year: 1965, recordLabel: 'Impulse!',
    catalog: 'A-77', format: 'LP, Album', country: 'US',
    genres: ['Jazz', 'Spiritual Jazz'], condition: 'Very Good (VG)',
    tracks: [
      { side: 'A', num: 1, title: 'Part I — Acknowledgement', duration: '7:43' },
      { side: 'A', num: 2, title: 'Part II — Resolution', duration: '7:20' },
      { side: 'B', num: 3, title: 'Part III — Pursuance', duration: '10:42' },
      { side: 'B', num: 4, title: 'Part IV — Psalm', duration: '7:05' },
    ],
  },
];

// Pick one random album per page load
const HERO_ALBUM = VINYL_ALBUMS[Math.floor(Math.random() * VINYL_ALBUMS.length)];

// ============================================
// COMPONENTS
// ============================================

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Logo = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };
  return (
    <img src="/logo2.png" alt="yday logo" className={`${sizes[size]} ${className} object-contain`} />
  );
};

const Navigation = () => null;

const Footer = () => (
  <footer className="border-t border-white/[0.04] py-8">
    <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2 group">
        <Logo size="sm" />
        <span className="text-sm font-semibold text-gray-500 group-hover:text-white transition-colors" style={{ fontFamily: 'David Libre, serif' }}>yday</span>
      </Link>
      <div className="flex items-center gap-6">
        <Link to="/about" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">About</Link>
        <Link to="/changelog" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">Changelog</Link>
      </div>
    </div>
  </footer>
);

const RecordInfoCard = ({ album }) => {
  // Group tracks by side
  const sides = {};
  album.tracks.forEach((t) => {
    if (!sides[t.side]) sides[t.side] = [];
    sides[t.side].push(t);
  });

  return (
    <div className="w-full md:w-[280px] md:h-[330px] lg:h-[370px] overflow-y-auto bg-[#111827]/90 backdrop-blur-xl border border-white/[0.06] rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.5)]">
      {/* Album header */}
      <div className="p-4 pb-2 text-center">
        <div className="flex justify-center mb-3">
          <div className="w-16 h-16 rounded-full overflow-hidden border border-white/10">
            <img src={album.label} alt={album.title} className="w-full h-full object-cover" />
          </div>
        </div>
        <h2 className="text-sm font-bold text-white leading-tight mb-0.5" style={{ fontFamily: 'David Libre, serif' }}>{album.title}</h2>
        <p className="text-gray-400 text-xs mb-2">{album.artist} &middot; {album.year}</p>
        <div className="flex flex-wrap gap-1 justify-center mb-3">
          {album.genres.map((g, i) => (
            <span key={i} className="text-[9px] font-medium px-2 py-0.5 rounded-full bg-white/[0.06] text-gray-400 border border-white/[0.05]">{g}</span>
          ))}
        </div>
      </div>

      {/* Pressing details */}
      <div className="mx-3 mb-3 bg-white/[0.03] border border-white/[0.05] rounded-xl p-3 space-y-2">
        {[
          ['Label', album.recordLabel],
          ['Cat #', album.catalog, true],
          ['Format', album.format],
          ['Condition', album.condition],
        ].map(([label, value, mono], i) => (
          <React.Fragment key={label}>
            {i > 0 && <div className="border-t border-white/[0.03]" />}
            <div className="flex items-center justify-between">
              <span className="text-[9px] uppercase tracking-wider text-gray-500">{label}</span>
              <span className={`text-[11px] text-gray-300 ${mono ? 'font-mono' : ''}`}>{value}</span>
            </div>
          </React.Fragment>
        ))}
      </div>

      {/* Tracklist */}
      <div className="mx-3 mb-3">
        <h3 className="text-[9px] uppercase tracking-[0.2em] text-gray-500 mb-2 px-1">Tracklist</h3>
        <div className="space-y-2">
          {Object.entries(sides).map(([side, tracks]) => (
            <div key={side}>
              <div className="text-[9px] uppercase tracking-wider text-gray-600 mb-1 px-1">Side {side}</div>
              <div className="bg-white/[0.02] border border-white/[0.04] rounded-lg overflow-hidden">
                {tracks.map((track, i) => (
                  <div key={track.num} className={`flex items-center px-2.5 py-1.5 ${i > 0 ? 'border-t border-white/[0.03]' : ''}`}>
                    <span className="text-[10px] text-gray-600 w-4 flex-shrink-0">{track.num}</span>
                    <span className="text-[11px] text-gray-300 flex-1 truncate">{track.title}</span>
                    <span className="text-[10px] text-gray-600 ml-1.5 flex-shrink-0">{track.duration}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scan badge */}
      <div className="mx-3 mb-3 flex items-center gap-2 bg-green-500/10 border border-green-500/20 rounded-lg px-3 py-2">
        <svg className="w-3.5 h-3.5 text-green-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p className="text-[10px] text-green-400 font-medium">Identified by yday</p>
      </div>
    </div>
  );
};


// ============================================
// HERO SECTION
// ============================================

const HeroSection = ({ album }) => (
  <Scrollytelling>
    <Pin childHeight="100vh" pinSpacerHeight="500vh" top={0}>
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-yday-dark via-indigo-950/20 to-yday-dark">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-900/15 via-transparent to-transparent" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-purple-900/10 via-transparent to-transparent" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-16">
          <div className="flex flex-col items-center">
            <div className="relative mb-8 md:mb-12 w-full" style={{ minHeight: '400px' }}>

              {/* Logo — centered, fades out and drifts left */}
              <div className="flex items-center justify-center">
                <Animation tween={[
                  { start: 3, end: 22, to: { opacity: 0, x: -40 } }
                ]}>
                  <div className="w-[260px] h-[260px] md:w-[360px] md:h-[360px] lg:w-[400px] lg:h-[400px] flex-shrink-0 rounded-2xl bg-gradient-to-br from-gray-800/90 to-gray-900/95 border border-white/[0.06] shadow-[0_8px_60px_rgba(0,0,0,0.4)] overflow-hidden">
                    <img src="/logo2.png" alt="yday" className="w-full h-full object-cover rounded-2xl opacity-90" />
                  </div>
                </Animation>
              </div>

              {/* Single record (mobile) — fades in centered, rotates */}
              <Animation tween={[
                { start: 3, end: 18, fromTo: [{ opacity: 0 }, { opacity: 1 }] },
                { start: 8, end: 98, to: { rotate: 360 } }
              ]}>
                <div className="absolute inset-0 flex items-center justify-center md:hidden">
                  <div className="w-[240px] h-[240px]">
                    <div className="vinyl-record w-full h-full rounded-full">
                      <div className="vinyl-label">
                        <div className="absolute inset-0 rounded-full overflow-hidden">
                          <img src={album.label} alt={`${album.title} label`} className="w-full h-full object-cover" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Animation>

              {/* Single record (desktop) — fades in centered, rotates, shifts left */}
              <Animation tween={[
                { start: 3, end: 18, fromTo: [{ opacity: 0 }, { opacity: 1 }] },
                { start: 8, end: 98, to: { rotate: 360 } },
                { start: 22, end: 35, to: { x: -140 } }
              ]}>
                <div className="absolute inset-0 hidden md:flex items-center justify-center">
                  <div className="w-[330px] h-[330px] lg:w-[370px] lg:h-[370px]">
                    <div className="vinyl-record w-full h-full rounded-full">
                      <div className="vinyl-label">
                        <div className="absolute inset-0 rounded-full overflow-hidden">
                          <img src={album.label} alt={`${album.title} label`} className="w-full h-full object-cover" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Animation>

              {/* Info card — fades in after record settles left, persists */}
              <Animation tween={[
                { start: 40, end: 52, fromTo: [{ opacity: 0, x: 30 }, { opacity: 1, x: 0 }] }
              ]}>
                <div className="absolute top-0 bottom-0 hidden md:flex items-center" style={{ left: 'calc(50% + 55px)' }}>
                  <RecordInfoCard album={album} />
                </div>
              </Animation>
            </div>

            {/* Text content */}
            <div className="relative text-center w-full" style={{ minHeight: 200 }}>
              {/* Tagline — fades out as record scene takes over */}
              <Animation tween={{ start: 15, end: 28, to: { opacity: 0, y: -20 } }}>
                <div className="absolute inset-x-0 top-0">
                  <p className="text-xl md:text-2xl lg:text-3xl text-gray-300 max-w-lg mx-auto leading-relaxed" style={{ fontFamily: 'David Libre, serif' }}>
                    From crate to catalog
                  </p>
                </div>
              </Animation>

              {/* Summary text — fades in while record+card are visible, all persist */}
              <Animation tween={[
                { start: 50, end: 60, fromTo: [{ opacity: 0, y: 20 }, { opacity: 1, y: 0 }] }
              ]}>
                <div className="absolute inset-x-0 top-0">
                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'David Libre, serif' }}>
                    Identify any pressing
                  </h2>
                  <p className="text-sm md:text-base text-gray-400/90 max-w-md mx-auto leading-relaxed">
                    Photo a barcode, sleeve, or label. yday matches the exact pressing — catalog number, format, country, condition.
                  </p>
                </div>
              </Animation>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <Animation tween={{ start: 8, end: 18, to: { opacity: 0 } }}>
          <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
            <span className="text-[9px] tracking-[0.3em] uppercase text-gray-600">scroll</span>
            <div className="w-px h-8 bg-gradient-to-b from-gray-600/50 to-transparent scroll-line" />
          </div>
        </Animation>
      </section>
    </Pin>
  </Scrollytelling>
);

// ============================================
// PAGES
// ============================================

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <HeroSection album={HERO_ALBUM} />

      {/* Built for collectors */}
      <Scrollytelling start="top 85%" end="top 20%">
        <section className="py-16 md:py-24">
          <Animation tween={{ start: 0, end: 50, fromTo: [{ opacity: 0, y: 30 }, { opacity: 1, y: 0 }] }}>
            <div className="max-w-3xl mx-auto px-6">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 tracking-tight text-center" style={{ fontFamily: 'David Libre, serif' }}>
                Built for collectors
              </h2>
              <div className="space-y-6 text-center mb-12">
                <p className="text-lg text-gray-300 max-w-xl mx-auto leading-relaxed">
                  yday is a tool for people who care about records. Scan a barcode, sleeve, or label and identify the exact pressing in seconds. Catalog your collection, track conditions, and list records for sale to people in your city.
                </p>
                <p className="text-lg text-gray-400 max-w-xl mx-auto leading-relaxed">
                  If you run a record shop, yday lets you scan and log inventory fast. Your shelves become browsable to anyone nearby, even outside opening hours. No more guessing what's in stock.
                </p>
                <p className="text-lg text-gray-400 max-w-xl mx-auto leading-relaxed">
                  We're in <span className="text-white font-medium">closed beta on iOS</span>, building with a small group of collectors and shops who want something better. If that sounds like you, get in touch.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="mailto:hello@yday.ai?subject=Beta access&body=I'd love to test yday! Here's a bit about my collection:"
                  className="inline-flex items-center justify-center gap-2 bg-white text-yday-dark font-medium px-7 py-3.5 rounded-full hover:bg-gray-100 transition-all duration-200 text-sm"
                >
                  Request beta access
                </a>
                <a
                  href="mailto:scan@yday.ai?subject=Scan my record&body=Attach a photo of your vinyl record and we'll identify it!"
                  className="inline-flex items-center justify-center gap-2 border border-white/[0.1] text-white font-medium px-7 py-3.5 rounded-full hover:bg-white/[0.05] transition-all duration-200 text-sm"
                >
                  <svg className="w-4 h-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  Try the email scanner
                </a>
              </div>
            </div>
          </Animation>
        </section>
      </Scrollytelling>
    </div>
  );
};

const About = () => (
  <div className="flex-1 pt-16 md:pt-24 flex items-start">
    <div className="max-w-2xl mx-auto px-6">
      <h1 className="text-5xl md:text-6xl font-bold text-white mb-10 tracking-tight" style={{ fontFamily: 'David Libre, serif' }}>
        About
      </h1>
      <div className="space-y-5 text-lg leading-relaxed">
        <p className="text-gray-300">
          yday is about discovering music the way it's meant to be discovered. In shops, in crates, through people. Not through algorithms that decide what you should like based on what you already listen to.
        </p>
        <p className="text-gray-400">
          Everything on yday is local. Browse what collectors and record shops near you actually have on their shelves. Find something you weren't looking for. Walk in and buy it.
        </p>
        <p className="text-gray-400">
          Closed beta on iOS. <a href="mailto:hello@yday.ai?subject=Beta access&body=I'd love to test yday! Here's a bit about my collection:" className="text-white hover:text-blue-400 transition-colors">Get in touch</a> if you want in.
        </p>
      </div>
    </div>
  </div>
);

const Changelog = () => {
  const changelog = [
    {
      version: '0.0.3',
      date: '2026-02-24',
      label: null,
      changes: [
        { type: 'added', text: 'Search & Discovery: search by genre, mood, decade, or natural language' },
        { type: 'added', text: 'Semantic tagging: genre and mood tags' },
        { type: 'added', text: 'Scan confidence scoring with review flow' },
        { type: 'added', text: '0.5x wide lens option for scanning' },
        { type: 'added', text: 'Parallel scan pipeline: barcode + cloud vision race for fastest match' },
        { type: 'added', text: 'Native on-device barcode scanning' },
        { type: 'added', text: 'Interactive flip-the-record text scanning' },
        { type: 'added', text: 'Feedback chat: bug reporting with photo attachments' },
        { type: 'added', text: 'Tag chips on record details' },
        { type: 'changed', text: 'Camera snaps to 1x when switching to barcode mode' },
        { type: 'changed', text: 'Faster version loading' },
        { type: 'fixed', text: 'Chat list images: album artwork and user avatars now load correctly' },
        { type: 'fixed', text: 'Chat showing wrong recipient name' },
        { type: 'fixed', text: '"In collection" badge logic corrected' },
      ],
    },
    {
      version: '0.0.2',
      date: '2026-02-15',
      label: null,
      changes: [
        { type: 'added', text: 'Email-based record scanning (scan@yday.ai)' },
        { type: 'added', text: 'Website with changelog at yday.ai' },
        { type: 'added', text: 'Album descriptions' },
        { type: 'added', text: 'For Sale marketplace browse' },
        { type: 'added', text: 'Chat messaging between buyers and sellers' },
      ],
    },
    {
      version: '0.0.1',
      date: '2026-02-08',
      label: null,
      changes: [
        { type: 'added', text: 'Initial TestFlight beta release' },
        { type: 'added', text: 'Google Sign-In and Apple Sign-In authentication' },
        { type: 'added', text: 'Demo account login for testers' },
        { type: 'added', text: 'Vinyl record scanning' },
        { type: 'added', text: 'Collection management with conditions and notes' },
        { type: 'added', text: 'User profiles with location sharing' },
      ],
    },
  ];

  const typeColors = {
    added: 'bg-green-500/20 text-green-400 border-green-500/30',
    changed: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    fixed: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    removed: 'bg-red-500/20 text-red-400 border-red-500/30',
  };

  return (
    <div className="min-h-screen pt-16 md:pt-24 pb-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4" style={{ fontFamily: 'David Libre, serif' }}>Changelog</h1>
          <p className="text-xl text-gray-400">All notable changes to yday</p>
        </div>

        <div className="space-y-8">
          {changelog.map((release, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-900/80 to-gray-800/80 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
              <div className="flex items-center gap-4 mb-6 pb-6 border-b border-white/10">
                <h2 className="text-3xl font-bold text-white" style={{ fontFamily: 'David Libre, serif' }}>{release.label || release.version}</h2>
                {release.date && <span className="text-gray-400 text-sm font-medium">{release.date}</span>}
                {release.label && <span className="text-xs text-gray-500 font-mono">{release.version}</span>}
              </div>
              <ul className="space-y-4">
                {release.changes.map((change, i) => (
                  <li key={i} className="flex items-start gap-4">
                    <span className={`text-xs font-semibold px-3 py-1.5 rounded-lg border flex-shrink-0 ${typeColors[change.type]}`}>
                      {change.type}
                    </span>
                    <span className="text-gray-300 flex-1">{change.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ============================================
// APP
// ============================================

const App = () => (
  <Router>
    <ScrollToTop />
    <div className="min-h-screen flex flex-col bg-yday-dark">
      <Navigation />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/changelog" element={<Changelog />} />
        </Routes>
      </main>
      <Footer />
    </div>
  </Router>
);

export default App;
